// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vv-M","largestCol":"styles_largestCol__BkIM8","smallestCol":"styles_smallestCol__6xb1v"};